/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/react/video-card.js":
/*!*******************************************!*\
  !*** ./js/components/react/video-card.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_1__);


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_ref => {
  var {
    video,
    sectionSettings
  } = _ref;
  var image_ratio = sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.imageRatio;
  var aspect_ratio;
  // { console.log('video',video) }

  var parsedFilterLook = json_6__WEBPACK_IMPORTED_MODULE_1___default().parse(video === null || video === void 0 ? void 0 : video.filter_look);
  if (image_ratio == "square") {
    aspect_ratio = "1";
  } else if (image_ratio == "landscape") {
    aspect_ratio = "1.77";
  } else if (image_ratio == "portrait") {
    aspect_ratio = "0.55";
  } else {
    aspect_ratio = "1.35";
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: video === null || video === void 0 ? void 0 : video.linked_page,
    className: "tw-group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-relative tw-overflow-hidden"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: video === null || video === void 0 ? void 0 : video.thumbnail_image,
    alt: video === null || video === void 0 ? void 0 : video.title,
    className: "tw-w-full tw-h-full tw-object-cover tw-rounded-[10px] tw-transition-transform tw-duration-500 hover:tw-scale-110",
    style: {
      aspectRatio: aspect_ratio
    }
  }), (sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.showTimerBlock) == "true" || (sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.showTimerBlock) == true && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-absolute tw-top-1/2 tw-z-[1] tw-left-1/2 tw-transform -tw-translate-x-1/2 -tw-translate-y-1/2 group-hover:tw-scale-110 tw-transition-transform tw-duration-300"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    width: "47",
    height: "62",
    viewBox: "0 0 47 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/sven g"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M47 31L9.13121e-08 62L2.80142e-06 -2.05444e-06L47 31Z",
    fill: "#FF8B00"
  }))), (sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.showTimerBlock) == "true" || (sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.showTimerBlock) == true && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-absolute tw-top-2 tw-right-2 tw-bg-[var(--gray-400)] tw-opacity-[0.7] tw-px-2 tw-py-1 tw-rounded tw-flex tw-gap-1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0593/6821/0503/files/access_time.svg?v=1740137796"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "tw-text-white tw-leading-none tw-text-sm lg:tw-text-base"
  }, " ", video === null || video === void 0 ? void 0 : video.duration))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "tw-mt-4 tw-leading-none tw-font-semibold tw-text-base lg:tw-text-xl artist-title-color"
  }, video === null || video === void 0 ? void 0 : video.title), (sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.showCategory) == "true" && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "tw-mt-2 tw-leading-none tw-font-normal tw-text-base lg:tw-text-lg"
  }, parsedFilterLook)));
});

/***/ }),

/***/ "./js/components/react/video-cards.js":
/*!********************************************!*\
  !*** ./js/components/react/video-cards.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _video_grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./video-grid */ "./js/components/react/video-grid.js");
/* harmony import */ var _video_slider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./video-slider */ "./js/components/react/video-slider.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_3__);


var _excluded = ["paginateUrl"];




/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_ref => {
  var {
    shopifyData = {}
  } = _ref;
  // Safely destructure with defaults
  var {
    data = {}
  } = shopifyData;
  var [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
  var [loadingError, setLoadingError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
  var {
    videos = [],
    sectionSettings = {},
    selectedCategory = ["ALL"],
    templateKeys = []
  } = data || {};
  var getMetafieldData = /*#__PURE__*/function () {
    var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* (url) {
      try {
        var _data = yield fetch(url);
        var res = yield _data.text();
        var parsedData = json_6__WEBPACK_IMPORTED_MODULE_3___default().parse(res);
        return parsedData;
      } catch (error) {
        console.error("Error fetching metafield data:", error);
        setLoadingError("Failed to load video data");
        return [];
      }
    });
    return function getMetafieldData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var finalData = [];
  var _recursivelyFetchData = /*#__PURE__*/function () {
    var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* (url) {
      try {
        var _responseData$, _responseData$2;
        var responseData = yield getMetafieldData(url);
        if (!responseData || !Array.isArray(responseData)) {
          console.warn("Invalid response data format:", responseData);
          return;
        }
        var mappedData = responseData.map(_ref4 => {
          var {
              paginateUrl
            } = _ref4,
            rest = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__["default"])(_ref4, _excluded);
          return rest;
        });
        finalData = [...mappedData, ...finalData];
        if (responseData[0] && (_responseData$ = responseData[0]) !== null && _responseData$ !== void 0 && _responseData$.paginateUrl && ((_responseData$2 = responseData[0]) === null || _responseData$2 === void 0 ? void 0 : _responseData$2.paginateUrl) !== "false") {
          var _responseData$3;
          yield _recursivelyFetchData((_responseData$3 = responseData[0]) === null || _responseData$3 === void 0 ? void 0 : _responseData$3.paginateUrl);
        }
      } catch (error) {
        console.error("Error in recursive fetch:", error);
      }
    });
    return function recursivelyFetchData(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  // Validate videos array
  var validVideos = Array.isArray(videos) ? videos : [];
  var [allVideos, setAllVideos] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([...validVideos]);
  var updateVideos = videos => {
    if (Array.isArray(videos)) {
      setAllVideos([...videos]);
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    ;
    (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* () {
      try {
        var url = window.location.href;
        var urlWithoutParams = url.split("?")[0];
        if (templateKeys.length > 0) {
          for (var key of templateKeys) {
            var metadataUrl = "".concat(urlWithoutParams, "?view=").concat(key);
            yield _recursivelyFetchData(metadataUrl);
          }
          setAllVideos(finalData.length > 0 ? finalData : validVideos);
        }
      } catch (error) {
        console.error("Error loading video data:", error);
        setLoadingError("Failed to load video data");
      } finally {
        setIsLoading(false);
        window.isLoadingCards = false;
      }
    })();

    // Cleanup function
    return () => {
      window.isLoadingCards = false;
    };
  }, []);

  // Validate sectionSettings
  var validSettings = typeof sectionSettings === "object" && sectionSettings !== null ? sectionSettings : {};
  var type = validSettings.type || "grid";
  if (loadingError) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "tw-flex tw-justify-center tw-items-center tw-h-32"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "tw-text-red-500"
    }, loadingError));
  }
  if (type === "grid") {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_video_grid__WEBPACK_IMPORTED_MODULE_4__["default"], {
      videos: allVideos,
      selectedCategory: selectedCategory,
      sectionSettings: validSettings
    });
  }
  if (type === "slider") {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_video_slider__WEBPACK_IMPORTED_MODULE_5__["default"], {
      videos: allVideos,
      sectionSettings: validSettings
    });
  }
  return null;
});

/***/ }),

/***/ "./js/components/react/video-filters.js":
/*!**********************************************!*\
  !*** ./js/components/react/video-filters.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_3__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



function debounce(func) {
  var _this = this;
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(_this, args);
    }, timeout);
  };
}

// 🛠️ Converts duration like "11:00" to seconds or parses float
function parseDuration(duration) {
  if (!duration) return 0;
  if (typeof duration === "number") return duration;
  if (duration.includes(":")) {
    var parts = duration.split(":").map(Number);
    if (parts.length === 2) {
      var [min, sec] = parts;
      return min * 60 + sec;
    } else if (parts.length === 3) {
      var [hr, _min, _sec] = parts;
      return hr * 3600 + _min * 60 + _sec;
    }
    return 0;
  }
  var parsed = parseFloat(duration);
  return isNaN(parsed) ? 0 : parsed;
}
var VideoFilter = _ref => {
  var {
    videos,
    setFilteredAndSortedVideos,
    main_page,
    isTitleSort = false,
    hideSort,
    hideFilter,
    filter_name
  } = _ref;
  var [isModalOpen, setIsModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [sortOrder, setSortOrder] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("recent");
  var [searchTerm, setSearchTerm] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
  var [filterStates, setFilterStates] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
  var [searchFilteredVideos, setSearchFilteredVideos] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(videos);
  var isAnyFilterActive = Object.values(filterStates).some(value => value !== "");
  var availableFilterTypes = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    if (!videos || videos.length === 0) return [];
    return Object.keys(videos[0] || {}).filter(key => key.startsWith("filter_")).map(key => key.replace("filter_", ""));
  }, [videos]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (availableFilterTypes.length > 0) {
      var initialFilters = {};
      availableFilterTypes.forEach(type => {
        initialFilters[type] = "";
      });
      setFilterStates(initialFilters);
    }
  }, [availableFilterTypes]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  var currentPageFilter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    var _json6$parse;
    var currentPage = document.querySelector("[data-current-page]");
    return currentPage ? ((_json6$parse = json_6__WEBPACK_IMPORTED_MODULE_3___default().parse(currentPage.innerHTML)) === null || _json6$parse === void 0 ? void 0 : _json6$parse.current_page) || [] : [];
  }, []);
  var parseFilterValues = filterValue => {
    if (!filterValue) return [];
    try {
      if (Array.isArray(filterValue)) return filterValue;
      var parsed = json_6__WEBPACK_IMPORTED_MODULE_3___default().parse(filterValue);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch (_unused) {
      return [filterValue];
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var filtered = videos.filter(video => {
      return searchTerm == "" || (video === null || video === void 0 ? void 0 : video.description.toLowerCase().includes(searchTerm.toLowerCase())) || video.title.toLowerCase().includes(searchTerm.toLowerCase());
    });
    setSearchFilteredVideos(filtered);
  }, [videos, searchTerm]);
  var filterOptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    var options = {};
    var sourceVideos = isAnyFilterActive ? videos : searchFilteredVideos;
    availableFilterTypes.forEach(type => {
      var relevantVideos = isAnyFilterActive ? sourceVideos.filter(video => {
        var matchesSearch = searchTerm === "" || video.title.toLowerCase().includes(searchTerm.toLowerCase());
        var matchesOtherFilters = Object.entries(filterStates).filter(_ref2 => {
          var [key] = _ref2;
          return key !== type;
        }).every(_ref3 => {
          var [key, value] = _ref3;
          if (!value) return true;
          var videoFilterValues = parseFilterValues(video["filter_".concat(key)]);
          return videoFilterValues.includes(value);
        });
        return matchesSearch && matchesOtherFilters;
      }) : sourceVideos;
      var uniqueValues = new Set();
      relevantVideos.forEach(video => {
        var filterValues = parseFilterValues(video["filter_".concat(type)]);
        filterValues.forEach(val => uniqueValues.add(val));
      });
      options[type] = Array.from(uniqueValues);
    });
    return options;
  }, [videos, searchFilteredVideos, availableFilterTypes, filterStates, searchTerm]);
  var updateFilter = (type, value) => {
    setFilterStates(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [type]: value
    }));
  };
  var debouncedSearch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => debounce(value => setSearchTerm(value), 300), []);
  var filteredAndSortedVideos = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    var filtered = videos.filter(video => {
      var matchesSearch = searchTerm === "" || video.title.toLowerCase().includes(searchTerm.toLowerCase()) || video.description.toLowerCase().includes(searchTerm.toLowerCase());
      var matchesFilters = Object.entries(filterStates).every(_ref4 => {
        var [key, value] = _ref4;
        if (!value) return true;
        var videoFilterValues = parseFilterValues(video["filter_".concat(key)]);
        return videoFilterValues.includes(value);
      });
      return matchesSearch && matchesFilters;
    });
    return [...filtered].sort((a, b) => {
      if (isTitleSort) {
        if (sortOrder === "recent") {
          return moment__WEBPACK_IMPORTED_MODULE_2___default()(b.entry_date).valueOf() - moment__WEBPACK_IMPORTED_MODULE_2___default()(a.entry_date).valueOf();
        } else if (sortOrder === "title-az") {
          return a.title.localeCompare(b.title);
        } else if (sortOrder === "title-za") {
          return b.title.localeCompare(a.title);
        }
      } else {
        var durationA = parseDuration(a.duration);
        var durationB = parseDuration(b.duration);
        if (sortOrder === "recent") {
          return moment__WEBPACK_IMPORTED_MODULE_2___default()(b.entry_date).valueOf() - moment__WEBPACK_IMPORTED_MODULE_2___default()(a.entry_date).valueOf();
        } else if (sortOrder === "length-long") {
          return durationB - durationA;
        } else if (sortOrder === "length-short") {
          return durationA - durationB;
        }
      }
      return 0;
    });
  }, [videos, searchTerm, sortOrder, filterStates]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    setFilteredAndSortedVideos(filteredAndSortedVideos);
  }, [filteredAndSortedVideos, setFilteredAndSortedVideos]);
  var clearFilters = () => {
    var clearedFilters = {};
    availableFilterTypes.forEach(type => {
      clearedFilters[type] = "";
    });
    setFilterStates(clearedFilters);
  };
  var opacityFilter = window.isLoadingCards == undefined || window.isLoadingCards == true ? "tw-opacity-25 tw-cursor-not-allowed tw-pointer-events-none" : "tw-opacity-100";
  var renderFilters = () => {
    return availableFilterTypes.map(type => {
      var _filterOptions$type;
      if (((_filterOptions$type = filterOptions[type]) === null || _filterOptions$type === void 0 ? void 0 : _filterOptions$type.length) > 0) {
        var displayLabel = type.toUpperCase() == "LOOK" ? "ALL" : type.toUpperCase();

        // Sort options so any option containing "other" (case-insensitive) is last
        var sortedOptions = [...filterOptions[type]].sort((a, b) => {
          var aStr = typeof a === "string" ? a : String(a);
          var bStr = typeof b === "string" ? b : String(b);
          var aIsOther = aStr.toLowerCase().includes("other");
          var bIsOther = bStr.toLowerCase().includes("other");
          if (aIsOther && !bIsOther) return 1;
          if (!aIsOther && bIsOther) return -1;
          return aStr.localeCompare(bStr);
        });
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("select", {
          key: type,
          className: "tw-px-4 tw-py-2 tw-text-[var(--gray-200)] tw-border-gray tw-min-w-[150px] sm:tw-max-w-[150px] tw-border-y md:tw-border-x md:tw-border-black ".concat(opacityFilter),
          value: filterStates[type],
          onChange: e => updateFilter(type, e.target.value)
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
          value: ""
        }, displayLabel), sortedOptions.map(option => {
          var displayValue = typeof option === "string" && option.startsWith("[") ? json_6__WEBPACK_IMPORTED_MODULE_3___default().parse(option) : option;
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
            key: option,
            value: option
          }, displayValue);
        }));
      }
      return null;
    });
  };
  var categoryOfPage = json_6__WEBPACK_IMPORTED_MODULE_3___default().parse(window.currentPage);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "container-wrapper tw-mx-auto tw-py-7 tw-border-b tw-border-t tw-bg-white search-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex tw-flex-wrap tw-items-center tw-gap-y-7 ".concat(!hideFilter ? "tw-justify-between" : "tw-justify-end")
  }, !hideFilter && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-hidden md:tw-flex tw-items-center tw-gap-4 mobile-filter-and-sort md:tw-flex-col lg:tw-flex-row"
  }, isMobile && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    onClick: () => setIsModalOpen(true),
    className: "md:tw-hidden  tw-capitalize"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "tw-block tw-w-5 tw-h-4"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0593/6821/0503/files/svgviewer-png-output.png?v=1741240945"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex tw-items-center tw-gap-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "md:tw-block tw-hidden tw-w-4"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0593/6821/0503/files/svgviewer-png-output.png?v=1741240945"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "tw-hidden tw-ml-auto tw-mr-auto lg:tw-mr-0 lg:tw-ml-0 md:tw-block"
  }, filter_name)), !isMobile && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex tw-items-center tw-gap-3 xl:tw-gap-6"
  }, renderFilters(), isAnyFilterActive && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    onClick: clearFilters,
    className: "tw-text-black tw-underline hover:tw-text-gray-900  tw-capitalize"
  }, "Clear Filter"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex tw-items-center tw-ml-auto tw-relative lg:tw-mr-0 lg:tw-ml-0 tw-w-full lg:tw-w-fit"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("input", {
    type: "text",
    placeholder: "SEARCH",
    className: "tw-border-b-[1.5px] tw-border-black tw-py-2 tw-pl-2 tw-pr-10 focus:tw-outline-none tw-w-full lg:tw-w-fit !tw-text-black",
    onChange: e => debouncedSearch(e.target.value)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0593/6821/0503/files/Group_6765.png?v=1741241462"
  }))))), isMobile && isModalOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-fixed tw-inset-0 tw-bg-opacity-50 tw-z-10",
    style: {
      background: "rgb(172 172 172 / var(--tw-bg-opacity))"
    },
    onClick: () => setIsModalOpen(false)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white tw-z-20 tw-p-4 tw-transform tw-transition-transform tw-duration-300 tw-ease-in-out",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-grid tw-gap-4"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex tw-justify-between tw-items-center tw-gap-1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-font-bold tw-text-base"
  }, filter_name), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    onClick: () => setIsModalOpen(false)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    className: "h-8 w-8 p-2 opacity-70 cursor-pointer  tw-capitalize"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
    d: "M0.757812 8.75781L4.75782 4.75783M4.75782 4.75783L8.7578 0.757812M4.75782 4.75783L0.757812 0.757812M4.75782 4.75783L8.7578 8.75781",
    stroke: "currentcolor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), renderFilters(), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex tw-gap-2 tw-items-center tw-justify-between"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-font-bold tw-text-base tw-whitespace-nowrap"
  }, "Sort By"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("select", {
    className: "tw-border tw-rounded tw-px-4 tw-py-2 ".concat(opacityFilter),
    value: sortOrder,
    onChange: e => setSortOrder(e.target.value)
  }, isTitleSort ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
    value: "recent"
  }, "Most Recent"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
    value: "title-az"
  }, "Alphabetically A-Z"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
    value: "title-za"
  }, "Alphabetically Z-A")) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
    value: "recent"
  }, "Most Recent"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
    value: "length-long"
  }, "Length: Long to Short"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
    value: "length-short"
  }, "Length: Short to Long")))), isAnyFilterActive && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    onClick: clearFilters,
    className: "tw-text-black tw-underline hover:tw-text-gray-900  tw-capitalize"
  }, "Clear Filter")))), !hideSort && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "container-wrapper tw-mx-auto tw-py-6 tw-bg-white"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex tw-justify-between tw-items-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-hidden md:tw-block"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("h2", {
    className: "tw-text-2xl tw-font-bold"
  }, categoryOfPage == 'ALL' ? 'VIDEOS' : categoryOfPage)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-block md:tw-hidden"
  }, main_page == "true" && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-mr-3 xl:tw-mr-6"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
    href: "/pages/education-connect",
    className: "tw-text-[var(--orange-200)] tw-underline"
  }, "Back to All videos"))), !isMobile && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex tw-items-center"
  }, main_page == "true" && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-mr-3 xl:tw-mr-6"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
    href: "/pages/education-connect",
    className: "tw-text-[var(--orange-200)] tw-underline"
  }, "Back to All videos")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "tw-mr-2"
  }, "Sort by:"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("select", {
    className: "tw-border tw-rounded tw-px-4 tw-py-2 ".concat(opacityFilter),
    value: sortOrder,
    onChange: e => setSortOrder(e.target.value)
  }, isTitleSort ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
    value: "recent"
  }, "Most Recent"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
    value: "title-az"
  }, "Alphabetically A-Z"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
    value: "title-za"
  }, "Alphabetically Z-A")) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
    value: "recent"
  }, "Most Recent"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
    value: "length-long"
  }, "Length: Long to Short"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("option", {
    value: "length-short"
  }, "Length: Short to Long")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "mobile-sort-filter-section md:tw-hidden"
  }, isMobile && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    onClick: () => setIsModalOpen(true),
    className: "tw-flex tw-gap-3 tw-flex-row-reverse md:tw-hidden  tw-capitalize"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", null, "Filter and sort"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "tw-block tw-w-5 tw-h-4"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0593/6821/0503/files/svgviewer-png-output.png?v=1741240945"
  })))))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (VideoFilter);

/***/ }),

/***/ "./js/components/react/video-grid.js":
/*!*******************************************!*\
  !*** ./js/components/react/video-grid.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _video_filters__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./video-filters */ "./js/components/react/video-filters.js");
/* harmony import */ var _video_card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./video-card */ "./js/components/react/video-card.js");



var VideoGrid = _ref => {
  var {
    videos,
    selectedCategory = selectedCategory || [],
    sectionSettings
  } = _ref;
  var [filteredAndSortedVideos, setFilteredAndSortedVideos] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  var gridViewColumns = (sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.gridViewColumns) || 3;
  var gridViewColumnsMobile = (sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.gridViewColumnsMobile) || 1;
  var hideSort = (sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.hideSort) || false;
  var hideFilter = (sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.hideFilter) || false;
  var showOnlyFilterWithSearch = (sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.showOnlyFilterWithSearch) || false;

  // Check if videos are loading
  var isLoading = typeof window !== 'undefined' && (window.isLoadingCards === undefined || window.isLoadingCards === true);
  var filteredVideos = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (!selectedCategory || selectedCategory.length === 0 || selectedCategory == "ALL") {
      return videos;
    }
    var selectedCategories = Array.isArray(selectedCategory) ? selectedCategory : [selectedCategory];
    return videos.filter(video => {
      var videoCategories = video.category || [];
      return selectedCategories.some(cat => videoCategories.includes(cat));
    });
  }, [videos, selectedCategory]);

  // Placeholder cards for loading state
  var placeholderCards = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    var count = isLoading ? 200 : filteredAndSortedVideos.length || 6;
    return Array(count).fill().map((_, index) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      key: "placeholder-".concat(index),
      className: "tw-animate-pulse"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "tw-bg-gray-200 tw-rounded-[10px] tw-aspect-square md:tw-w-[319px] md:tw-h-[180px]"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "tw-mt-2 tw-h-4 tw-bg-gray-200 tw-rounded"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "tw-mt-2 tw-h-4 tw-bg-gray-200 tw-rounded tw-w-3/4"
    })));
  }, [filteredAndSortedVideos.length, isLoading]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_video_filters__WEBPACK_IMPORTED_MODULE_1__["default"], {
    videos: filteredVideos,
    setFilteredAndSortedVideos: setFilteredAndSortedVideos,
    isTitleSort: sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.isTitleSort,
    main_page: sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.main_page,
    filter_name: sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.filter_name,
    hideSort: hideSort,
    hideFilter: hideFilter
  }), !showOnlyFilterWithSearch && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "container-wrapper tw-mx-auto tw-bg-white ".concat(!hideSort ? "tw-pb-6" : "tw-p-6")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-grid grid-cols-".concat(gridViewColumnsMobile, " md:grid-cols-").concat(gridViewColumns, " tw-gap-4 xl:tw-gap-7")
  }, (sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.showCustomBlock) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.customBlockButtonUrl,
    className: "tw-group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-relative"
  }, (sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.customBlockButtonUrl) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-relative tw-hidden md:tw-block"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.customBlockImage,
    alt: sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.customBlockTitle,
    className: "tw-w-full tw-object-cover tw-rounded-[10px]"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-relative tw-block md:tw-hidden"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.customBlockImageMobile,
    alt: sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.customBlockTitle,
    className: "tw-w-full tw-object-cover tw-rounded-[10px] tw-aspect-square"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-z-[2] tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-px-[20px] tw-py-[25px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "tw-leading-none tw-font-bold tw-uppercase tw-text-base lg:tw-text-xl tw-text-white"
  }, sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.customBlockTitle), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    className: " tw-capitalize p-break-words empty:hidden pointer-events-auto inline-block button mx-auto pl-6 pr-6 lg:pl-9 lg:pr-9 pt-2.5 pb-2.5 md:pt-3 md:pb-3 button--template--16197707104327__video_with_text_H3UG7r pointer-events-auto button-solid mt-3"
  }, sectionSettings === null || sectionSettings === void 0 ? void 0 : sectionSettings.customBlockButtonText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-z-[1] tw-bottom-0 tw-top-auto tw-rounded-[10px] tw-h-full tw-w-full tw-absolute tw-top-0 tw-left-0 tw-bg-gradient-to-t tw-to-transparent custom-gradient"
  }))), isLoading ? placeholderCards : filteredAndSortedVideos.map((video, index) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_video_card__WEBPACK_IMPORTED_MODULE_2__["default"], {
    key: "video-".concat(index),
    video: video,
    sectionSettings: sectionSettings
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (VideoGrid);

/***/ }),

/***/ "./js/components/react/video-slider.js":
/*!*********************************************!*\
  !*** ./js/components/react/video-slider.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (videos => {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", null, " This is video cards slider");
});

/***/ }),

/***/ "./js/components/video-cards-wrapper.js":
/*!**********************************************!*\
  !*** ./js/components/video-cards-wrapper.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _react_video_cards__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./react/video-cards */ "./js/components/react/video-cards.js");
/* harmony import */ var _react_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./react-wrapper */ "./js/components/react-wrapper.js");


class VideoCardsWrapper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    // Set a small delay to ensure DOM is fully ready
    setTimeout(() => {
      this.initializeVideoLibrary();
    }, 100);
  }
  initializeVideoLibrary() {
    // Set a global flag to track initialization
    if (!window.videoCardsInitializing) {
      window.videoCardsInitializing = true;

      // Check if the target element exists before rendering
      var videoCardsElement = document.querySelector("#video-cards-data");
      if (videoCardsElement) {
        (0,_react_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(_react_video_cards__WEBPACK_IMPORTED_MODULE_1__["default"], "video-cards", "#video-cards-data");
      } else {
        console.error("Video cards data element not found");
        window.videoCardsInitializing = false;
      }
    }
  }
}
customElements.define("video-cards-wrapper", VideoCardsWrapper);

/***/ }),

/***/ "./js/sections/accordian.js":
/*!**********************************!*\
  !*** ./js/sections/accordian.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  var accordionButton = document.querySelector(".accordion-button");
  var accordionContent = document.querySelector(".accordion-content");
  var accordionIcon = document.querySelector(".accordion-icon");
  accordionButton === null || accordionButton === void 0 || accordionButton.addEventListener("click", function () {
    accordionContent.classList.toggle("tw-hidden");
    accordionIcon.style.transform = accordionContent.classList.contains("tw-hidden") ? "rotate(0deg)" : "rotate(180deg)";
  });
});

/***/ }),

/***/ "./js/sections/blog-search.js":
/*!************************************!*\
  !*** ./js/sections/blog-search.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  var blogSearch = document.querySelector('#blogSearch');
  var allArticles = document.querySelectorAll('.grid-item');
  var searchResultsInfo = document.createElement('div');
  searchResultsInfo.id = 'searchResultsInfo';
  searchResultsInfo.className = 'tw-hidden tw-py-2 tw-text-center tw-min-w-[170px] md:tw-min-w-[200px]';
  blogSearch === null || blogSearch === void 0 || blogSearch.parentNode.insertBefore(searchResultsInfo, blogSearch.nextSibling);
  blogSearch === null || blogSearch === void 0 || blogSearch.addEventListener('input', function () {
    var searchQuery = this.value.toLowerCase().trim();
    var visibleCount = 0;
    allArticles.forEach(article => {
      var _article$querySelecto, _article$querySelecto2, _article$querySelecto3;
      // Get article title from h3 element
      var title = ((_article$querySelecto = article.querySelector('h3')) === null || _article$querySelecto === void 0 ? void 0 : _article$querySelecto.textContent.toLowerCase()) || '';

      // Get article excerpt if available
      var excerpt = ((_article$querySelecto2 = article.querySelector('.article-excerpt')) === null || _article$querySelecto2 === void 0 ? void 0 : _article$querySelecto2.textContent.toLowerCase()) || ((_article$querySelecto3 = article.querySelector('.line-clamp-2')) === null || _article$querySelecto3 === void 0 ? void 0 : _article$querySelecto3.textContent.toLowerCase()) || '';

      // Get article tags if available
      var tags = Array.from(article.querySelectorAll('ul.text-xs a')).map(tag => tag.textContent.toLowerCase()).join(' ') || '';

      // Check if search query matches any of the article content
      if (searchQuery === '' || title.includes(searchQuery) || excerpt.includes(searchQuery) || tags.includes(searchQuery)) {
        article.style.display = 'block';
        visibleCount++;
      } else {
        article.style.display = 'none';
      }
    });

    // Update search results info
    if (searchQuery.length > 0) {
      searchResultsInfo.classList.remove('tw-hidden');
      searchResultsInfo.textContent = "Found ".concat(visibleCount, " ").concat(visibleCount === 1 ? 'result' : 'results');
    } else {
      searchResultsInfo.classList.add('tw-hidden');
    }
  });
});

/***/ }),

/***/ "./js/sections/educational-content.js":
/*!********************************************!*\
  !*** ./js/sections/educational-content.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  var readMoreBtn = document.querySelectorAll('[data-read-more-btn]');
  var shortDescription = document.querySelectorAll('[data-short-description]');
  var fullDescription = document.querySelectorAll('[data-full-description]');
  if (readMoreBtn.length && shortDescription.length && fullDescription.length) {
    readMoreBtn.forEach((button, index) => {
      button.addEventListener('click', function () {
        if (fullDescription[index].style.display == 'none') {
          fullDescription[index].style.display = 'block';
          shortDescription[index].style.display = 'none';
          button.textContent = 'Read Less';
        } else {
          fullDescription[index].style.display = 'none';
          shortDescription[index].style.display = 'block';
          button.textContent = 'Read More';
        }
      });
    });
  }
});

/***/ }),

/***/ "./js/sections/read-more.js":
/*!**********************************!*\
  !*** ./js/sections/read-more.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  var btn = document.querySelector("[data-toggle='description']");
  var shortText = document.querySelector("[data-short-text]");
  var fullText = document.querySelector("[data-full-text]");
  if (btn) {
    btn.addEventListener("click", () => {
      shortText.classList.add("tw-hidden");
      fullText.classList.remove("tw-hidden");
      fullText.classList.remove("tw-block");
      btn.classList.add("hidden");
    });
  }
});

/***/ }),

/***/ "./js/sections/scroll-reviews.js":
/*!***************************************!*\
  !*** ./js/sections/scroll-reviews.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  setTimeout(() => {
    var review = document.querySelector('[data-views-tracked]');
    var productInfo = document.querySelector('[data-tabs-container]');
    review === null || review === void 0 || review.addEventListener('click', () => {
      productInfo.scrollIntoView({
        behavior: 'smooth'
      });
    });
  }, 2000);
});

/***/ }),

/***/ "./js/sections/sections.js":
/*!*********************************!*\
  !*** ./js/sections/sections.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _educational_content__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./educational-content */ "./js/sections/educational-content.js");
/* harmony import */ var _components_video_cards_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/video-cards-wrapper */ "./js/components/video-cards-wrapper.js");
/* harmony import */ var _variantOptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./variantOptions */ "./js/sections/variantOptions.js");
/* harmony import */ var _read_more__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./read-more */ "./js/sections/read-more.js");
/* harmony import */ var _accordian__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./accordian */ "./js/sections/accordian.js");
/* harmony import */ var _scroll_reviews__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./scroll-reviews */ "./js/sections/scroll-reviews.js");
/* harmony import */ var _blog_search__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./blog-search */ "./js/sections/blog-search.js");







document.addEventListener("DOMContentLoaded", () => {
  // Check if custom elements are already defined to prevent errors
  if (!customElements.get("video-cards-wrapper")) {
    customElements.define("video-cards-wrapper", _components_video_cards_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"]);
  }

  // Initialize variant options with a slight delay to ensure DOM is ready
  setTimeout(() => {
    try {
      (0,_variantOptions__WEBPACK_IMPORTED_MODULE_1__["default"])();
      console.log("Variant options initialized");
    } catch (e) {
      console.error("Error initializing variant options:", e);
    }
  }, 100);

  // Initialize other components
  (0,_educational_content__WEBPACK_IMPORTED_MODULE_2__["default"])();
  (0,_read_more__WEBPACK_IMPORTED_MODULE_3__["default"])();
  (0,_accordian__WEBPACK_IMPORTED_MODULE_4__["default"])();
  // Set global loading state
  window.isLoadingCards = true;
});

// Add a fallback initialization for when DOMContentLoaded has already fired
if (document.readyState === "complete" || document.readyState === "interactive") {
  if (!customElements.get("video-cards-wrapper")) {
    customElements.define("video-cards-wrapper", _components_video_cards_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"]);
  }

  // Initialize variant options with a slight delay to ensure DOM is ready
  setTimeout(() => {
    try {
      (0,_variantOptions__WEBPACK_IMPORTED_MODULE_1__["default"])();
      console.log("Variant options initialized (fallback)");
    } catch (e) {
      console.error("Error initializing variant options (fallback):", e);
    }
  }, 100);

  // Initialize other components
  (0,_educational_content__WEBPACK_IMPORTED_MODULE_2__["default"])();
  (0,_read_more__WEBPACK_IMPORTED_MODULE_3__["default"])();
  (0,_accordian__WEBPACK_IMPORTED_MODULE_4__["default"])();

  // Set global loading state
  window.isLoadingCards = true;
  (0,_scroll_reviews__WEBPACK_IMPORTED_MODULE_5__["default"])();
  (0,_blog_search__WEBPACK_IMPORTED_MODULE_6__["default"])();
}

// Add a mutation observer to detect when variant-selector is added to the DOM
var observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === "childList" && mutation.addedNodes.length) {
      // Check if variant-selector was added
      var variantSelector = document.querySelector("variant-selector");
      if (variantSelector && !variantSelector.dataset.initialized) {
        setTimeout(() => {
          try {
            (0,_variantOptions__WEBPACK_IMPORTED_MODULE_1__["default"])();
            console.log("Variant options initialized (observer)");
          } catch (e) {
            console.error("Error initializing variant options (observer):", e);
          }
        }, 100);
      }
    }
  });
});

// Start observing the document body for changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});

/***/ }),

/***/ "./js/sections/variantOptions.js":
/*!***************************************!*\
  !*** ./js/sections/variantOptions.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/react-wrapper */ "./js/components/react-wrapper.js");
/* harmony import */ var ReactComponents_variant_selector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ReactComponents/variant-selector */ "./js/components/react/variant-selector.js");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  // Check if the variant selector element exists
  var variantSelector = document.querySelector("variant-selector");
  if (!variantSelector) {
    console.warn("Variant selector element not found");
    return;
  }

  // Check if it's already initialized
  if (variantSelector.dataset.initialized === "true") {
    // console.log("Variant selector already initialized")
    return;
  }
  try {
    console.log("Initializing variant selector");

    // Initialize the React component
    (0,JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(ReactComponents_variant_selector__WEBPACK_IMPORTED_MODULE_1__["default"], "variant-selector", "#variant-data");

    // Add a retry mechanism if the data wasn't properly loaded
    setTimeout(() => {
      var variantSelector = document.querySelector("variant-selector");
      if (variantSelector && !variantSelector.querySelector(".variant-container__purchaseType-wrapper")) {
        console.log("Subscription options not rendered, retrying initialization");
        variantSelector.dataset.initialized = "false";
        (0,JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(ReactComponents_variant_selector__WEBPACK_IMPORTED_MODULE_1__["default"], "variant-selector", "#variant-data");
      }
    }, 500);
    return true;
  } catch (error) {
    console.error("Error initializing variant selector:", error);
    return false;
  }
});

/***/ }),

/***/ "./node_modules/moment/locale sync recursive ^\\.\\/.*$":
/*!***************************************************!*\
  !*** ./node_modules/moment/locale/ sync ^\.\/.*$ ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./af": "./node_modules/moment/locale/af.js",
	"./af.js": "./node_modules/moment/locale/af.js",
	"./ar": "./node_modules/moment/locale/ar.js",
	"./ar-dz": "./node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "./node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ps": "./node_modules/moment/locale/ar-ps.js",
	"./ar-ps.js": "./node_modules/moment/locale/ar-ps.js",
	"./ar-sa": "./node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "./node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/moment/locale/ar-tn.js",
	"./ar.js": "./node_modules/moment/locale/ar.js",
	"./az": "./node_modules/moment/locale/az.js",
	"./az.js": "./node_modules/moment/locale/az.js",
	"./be": "./node_modules/moment/locale/be.js",
	"./be.js": "./node_modules/moment/locale/be.js",
	"./bg": "./node_modules/moment/locale/bg.js",
	"./bg.js": "./node_modules/moment/locale/bg.js",
	"./bm": "./node_modules/moment/locale/bm.js",
	"./bm.js": "./node_modules/moment/locale/bm.js",
	"./bn": "./node_modules/moment/locale/bn.js",
	"./bn-bd": "./node_modules/moment/locale/bn-bd.js",
	"./bn-bd.js": "./node_modules/moment/locale/bn-bd.js",
	"./bn.js": "./node_modules/moment/locale/bn.js",
	"./bo": "./node_modules/moment/locale/bo.js",
	"./bo.js": "./node_modules/moment/locale/bo.js",
	"./br": "./node_modules/moment/locale/br.js",
	"./br.js": "./node_modules/moment/locale/br.js",
	"./bs": "./node_modules/moment/locale/bs.js",
	"./bs.js": "./node_modules/moment/locale/bs.js",
	"./ca": "./node_modules/moment/locale/ca.js",
	"./ca.js": "./node_modules/moment/locale/ca.js",
	"./cs": "./node_modules/moment/locale/cs.js",
	"./cs.js": "./node_modules/moment/locale/cs.js",
	"./cv": "./node_modules/moment/locale/cv.js",
	"./cv.js": "./node_modules/moment/locale/cv.js",
	"./cy": "./node_modules/moment/locale/cy.js",
	"./cy.js": "./node_modules/moment/locale/cy.js",
	"./da": "./node_modules/moment/locale/da.js",
	"./da.js": "./node_modules/moment/locale/da.js",
	"./de": "./node_modules/moment/locale/de.js",
	"./de-at": "./node_modules/moment/locale/de-at.js",
	"./de-at.js": "./node_modules/moment/locale/de-at.js",
	"./de-ch": "./node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "./node_modules/moment/locale/de-ch.js",
	"./de.js": "./node_modules/moment/locale/de.js",
	"./dv": "./node_modules/moment/locale/dv.js",
	"./dv.js": "./node_modules/moment/locale/dv.js",
	"./el": "./node_modules/moment/locale/el.js",
	"./el.js": "./node_modules/moment/locale/el.js",
	"./en-au": "./node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/moment/locale/en-au.js",
	"./en-ca": "./node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "./node_modules/moment/locale/en-ca.js",
	"./en-gb": "./node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/moment/locale/en-gb.js",
	"./en-ie": "./node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "./node_modules/moment/locale/en-ie.js",
	"./en-il": "./node_modules/moment/locale/en-il.js",
	"./en-il.js": "./node_modules/moment/locale/en-il.js",
	"./en-in": "./node_modules/moment/locale/en-in.js",
	"./en-in.js": "./node_modules/moment/locale/en-in.js",
	"./en-nz": "./node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "./node_modules/moment/locale/en-nz.js",
	"./en-sg": "./node_modules/moment/locale/en-sg.js",
	"./en-sg.js": "./node_modules/moment/locale/en-sg.js",
	"./eo": "./node_modules/moment/locale/eo.js",
	"./eo.js": "./node_modules/moment/locale/eo.js",
	"./es": "./node_modules/moment/locale/es.js",
	"./es-do": "./node_modules/moment/locale/es-do.js",
	"./es-do.js": "./node_modules/moment/locale/es-do.js",
	"./es-mx": "./node_modules/moment/locale/es-mx.js",
	"./es-mx.js": "./node_modules/moment/locale/es-mx.js",
	"./es-us": "./node_modules/moment/locale/es-us.js",
	"./es-us.js": "./node_modules/moment/locale/es-us.js",
	"./es.js": "./node_modules/moment/locale/es.js",
	"./et": "./node_modules/moment/locale/et.js",
	"./et.js": "./node_modules/moment/locale/et.js",
	"./eu": "./node_modules/moment/locale/eu.js",
	"./eu.js": "./node_modules/moment/locale/eu.js",
	"./fa": "./node_modules/moment/locale/fa.js",
	"./fa.js": "./node_modules/moment/locale/fa.js",
	"./fi": "./node_modules/moment/locale/fi.js",
	"./fi.js": "./node_modules/moment/locale/fi.js",
	"./fil": "./node_modules/moment/locale/fil.js",
	"./fil.js": "./node_modules/moment/locale/fil.js",
	"./fo": "./node_modules/moment/locale/fo.js",
	"./fo.js": "./node_modules/moment/locale/fo.js",
	"./fr": "./node_modules/moment/locale/fr.js",
	"./fr-ca": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "./node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/moment/locale/fr-ch.js",
	"./fr.js": "./node_modules/moment/locale/fr.js",
	"./fy": "./node_modules/moment/locale/fy.js",
	"./fy.js": "./node_modules/moment/locale/fy.js",
	"./ga": "./node_modules/moment/locale/ga.js",
	"./ga.js": "./node_modules/moment/locale/ga.js",
	"./gd": "./node_modules/moment/locale/gd.js",
	"./gd.js": "./node_modules/moment/locale/gd.js",
	"./gl": "./node_modules/moment/locale/gl.js",
	"./gl.js": "./node_modules/moment/locale/gl.js",
	"./gom-deva": "./node_modules/moment/locale/gom-deva.js",
	"./gom-deva.js": "./node_modules/moment/locale/gom-deva.js",
	"./gom-latn": "./node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/moment/locale/gom-latn.js",
	"./gu": "./node_modules/moment/locale/gu.js",
	"./gu.js": "./node_modules/moment/locale/gu.js",
	"./he": "./node_modules/moment/locale/he.js",
	"./he.js": "./node_modules/moment/locale/he.js",
	"./hi": "./node_modules/moment/locale/hi.js",
	"./hi.js": "./node_modules/moment/locale/hi.js",
	"./hr": "./node_modules/moment/locale/hr.js",
	"./hr.js": "./node_modules/moment/locale/hr.js",
	"./hu": "./node_modules/moment/locale/hu.js",
	"./hu.js": "./node_modules/moment/locale/hu.js",
	"./hy-am": "./node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "./node_modules/moment/locale/hy-am.js",
	"./id": "./node_modules/moment/locale/id.js",
	"./id.js": "./node_modules/moment/locale/id.js",
	"./is": "./node_modules/moment/locale/is.js",
	"./is.js": "./node_modules/moment/locale/is.js",
	"./it": "./node_modules/moment/locale/it.js",
	"./it-ch": "./node_modules/moment/locale/it-ch.js",
	"./it-ch.js": "./node_modules/moment/locale/it-ch.js",
	"./it.js": "./node_modules/moment/locale/it.js",
	"./ja": "./node_modules/moment/locale/ja.js",
	"./ja.js": "./node_modules/moment/locale/ja.js",
	"./jv": "./node_modules/moment/locale/jv.js",
	"./jv.js": "./node_modules/moment/locale/jv.js",
	"./ka": "./node_modules/moment/locale/ka.js",
	"./ka.js": "./node_modules/moment/locale/ka.js",
	"./kk": "./node_modules/moment/locale/kk.js",
	"./kk.js": "./node_modules/moment/locale/kk.js",
	"./km": "./node_modules/moment/locale/km.js",
	"./km.js": "./node_modules/moment/locale/km.js",
	"./kn": "./node_modules/moment/locale/kn.js",
	"./kn.js": "./node_modules/moment/locale/kn.js",
	"./ko": "./node_modules/moment/locale/ko.js",
	"./ko.js": "./node_modules/moment/locale/ko.js",
	"./ku": "./node_modules/moment/locale/ku.js",
	"./ku-kmr": "./node_modules/moment/locale/ku-kmr.js",
	"./ku-kmr.js": "./node_modules/moment/locale/ku-kmr.js",
	"./ku.js": "./node_modules/moment/locale/ku.js",
	"./ky": "./node_modules/moment/locale/ky.js",
	"./ky.js": "./node_modules/moment/locale/ky.js",
	"./lb": "./node_modules/moment/locale/lb.js",
	"./lb.js": "./node_modules/moment/locale/lb.js",
	"./lo": "./node_modules/moment/locale/lo.js",
	"./lo.js": "./node_modules/moment/locale/lo.js",
	"./lt": "./node_modules/moment/locale/lt.js",
	"./lt.js": "./node_modules/moment/locale/lt.js",
	"./lv": "./node_modules/moment/locale/lv.js",
	"./lv.js": "./node_modules/moment/locale/lv.js",
	"./me": "./node_modules/moment/locale/me.js",
	"./me.js": "./node_modules/moment/locale/me.js",
	"./mi": "./node_modules/moment/locale/mi.js",
	"./mi.js": "./node_modules/moment/locale/mi.js",
	"./mk": "./node_modules/moment/locale/mk.js",
	"./mk.js": "./node_modules/moment/locale/mk.js",
	"./ml": "./node_modules/moment/locale/ml.js",
	"./ml.js": "./node_modules/moment/locale/ml.js",
	"./mn": "./node_modules/moment/locale/mn.js",
	"./mn.js": "./node_modules/moment/locale/mn.js",
	"./mr": "./node_modules/moment/locale/mr.js",
	"./mr.js": "./node_modules/moment/locale/mr.js",
	"./ms": "./node_modules/moment/locale/ms.js",
	"./ms-my": "./node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "./node_modules/moment/locale/ms-my.js",
	"./ms.js": "./node_modules/moment/locale/ms.js",
	"./mt": "./node_modules/moment/locale/mt.js",
	"./mt.js": "./node_modules/moment/locale/mt.js",
	"./my": "./node_modules/moment/locale/my.js",
	"./my.js": "./node_modules/moment/locale/my.js",
	"./nb": "./node_modules/moment/locale/nb.js",
	"./nb.js": "./node_modules/moment/locale/nb.js",
	"./ne": "./node_modules/moment/locale/ne.js",
	"./ne.js": "./node_modules/moment/locale/ne.js",
	"./nl": "./node_modules/moment/locale/nl.js",
	"./nl-be": "./node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "./node_modules/moment/locale/nl-be.js",
	"./nl.js": "./node_modules/moment/locale/nl.js",
	"./nn": "./node_modules/moment/locale/nn.js",
	"./nn.js": "./node_modules/moment/locale/nn.js",
	"./oc-lnc": "./node_modules/moment/locale/oc-lnc.js",
	"./oc-lnc.js": "./node_modules/moment/locale/oc-lnc.js",
	"./pa-in": "./node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "./node_modules/moment/locale/pa-in.js",
	"./pl": "./node_modules/moment/locale/pl.js",
	"./pl.js": "./node_modules/moment/locale/pl.js",
	"./pt": "./node_modules/moment/locale/pt.js",
	"./pt-br": "./node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "./node_modules/moment/locale/pt-br.js",
	"./pt.js": "./node_modules/moment/locale/pt.js",
	"./ro": "./node_modules/moment/locale/ro.js",
	"./ro.js": "./node_modules/moment/locale/ro.js",
	"./ru": "./node_modules/moment/locale/ru.js",
	"./ru.js": "./node_modules/moment/locale/ru.js",
	"./sd": "./node_modules/moment/locale/sd.js",
	"./sd.js": "./node_modules/moment/locale/sd.js",
	"./se": "./node_modules/moment/locale/se.js",
	"./se.js": "./node_modules/moment/locale/se.js",
	"./si": "./node_modules/moment/locale/si.js",
	"./si.js": "./node_modules/moment/locale/si.js",
	"./sk": "./node_modules/moment/locale/sk.js",
	"./sk.js": "./node_modules/moment/locale/sk.js",
	"./sl": "./node_modules/moment/locale/sl.js",
	"./sl.js": "./node_modules/moment/locale/sl.js",
	"./sq": "./node_modules/moment/locale/sq.js",
	"./sq.js": "./node_modules/moment/locale/sq.js",
	"./sr": "./node_modules/moment/locale/sr.js",
	"./sr-cyrl": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/moment/locale/sr.js",
	"./ss": "./node_modules/moment/locale/ss.js",
	"./ss.js": "./node_modules/moment/locale/ss.js",
	"./sv": "./node_modules/moment/locale/sv.js",
	"./sv.js": "./node_modules/moment/locale/sv.js",
	"./sw": "./node_modules/moment/locale/sw.js",
	"./sw.js": "./node_modules/moment/locale/sw.js",
	"./ta": "./node_modules/moment/locale/ta.js",
	"./ta.js": "./node_modules/moment/locale/ta.js",
	"./te": "./node_modules/moment/locale/te.js",
	"./te.js": "./node_modules/moment/locale/te.js",
	"./tet": "./node_modules/moment/locale/tet.js",
	"./tet.js": "./node_modules/moment/locale/tet.js",
	"./tg": "./node_modules/moment/locale/tg.js",
	"./tg.js": "./node_modules/moment/locale/tg.js",
	"./th": "./node_modules/moment/locale/th.js",
	"./th.js": "./node_modules/moment/locale/th.js",
	"./tk": "./node_modules/moment/locale/tk.js",
	"./tk.js": "./node_modules/moment/locale/tk.js",
	"./tl-ph": "./node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/moment/locale/tl-ph.js",
	"./tlh": "./node_modules/moment/locale/tlh.js",
	"./tlh.js": "./node_modules/moment/locale/tlh.js",
	"./tr": "./node_modules/moment/locale/tr.js",
	"./tr.js": "./node_modules/moment/locale/tr.js",
	"./tzl": "./node_modules/moment/locale/tzl.js",
	"./tzl.js": "./node_modules/moment/locale/tzl.js",
	"./tzm": "./node_modules/moment/locale/tzm.js",
	"./tzm-latn": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/moment/locale/tzm.js",
	"./ug-cn": "./node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "./node_modules/moment/locale/ug-cn.js",
	"./uk": "./node_modules/moment/locale/uk.js",
	"./uk.js": "./node_modules/moment/locale/uk.js",
	"./ur": "./node_modules/moment/locale/ur.js",
	"./ur.js": "./node_modules/moment/locale/ur.js",
	"./uz": "./node_modules/moment/locale/uz.js",
	"./uz-latn": "./node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/moment/locale/uz-latn.js",
	"./uz.js": "./node_modules/moment/locale/uz.js",
	"./vi": "./node_modules/moment/locale/vi.js",
	"./vi.js": "./node_modules/moment/locale/vi.js",
	"./x-pseudo": "./node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/moment/locale/x-pseudo.js",
	"./yo": "./node_modules/moment/locale/yo.js",
	"./yo.js": "./node_modules/moment/locale/yo.js",
	"./zh-cn": "./node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "./node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/moment/locale/zh-hk.js",
	"./zh-mo": "./node_modules/moment/locale/zh-mo.js",
	"./zh-mo.js": "./node_modules/moment/locale/zh-mo.js",
	"./zh-tw": "./node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/moment/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/moment/locale sync recursive ^\\.\\/.*$";

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"sections": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors","shared"], () => (__webpack_require__("./js/sections/sections.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;